import React, { useContext } from "react";
import { getPhaseRSC } from 'helpers/rsc'
import { getCurrentRound } from "components/sports/glf/helper/GLFHelper";
import Competitor from 'components/presentation/Competitor';
import Label from "components/general/Label"
import Noc from 'components/presentation/Noc';
import Table from 'react-bootstrap/Table'
import SportCode from 'components/common/SportCode'
import 'styles/sports/glf.scss';

// Accordion stuff
// All is needed because default buttons has been changed to custom buttons to show +, - symbols
import Accordion from 'react-bootstrap/Accordion';
import AccordionContext from "react-bootstrap/AccordionContext";
import { useAccordionButton } from 'react-bootstrap/AccordionButton';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faMinus } from "@fortawesome/free-solid-svg-icons";
import Card from 'react-bootstrap/Card';
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";

// shows table with all participants
const TeeTimesTable = ({ data }) => {
  const { mirs_discipline } = useUrlFriendlyToParameters()

  return (
    <Table striped >
      <thead>
        <tr>
          <th className="text-center"><Label data="Tee" /></th>
          <th className="text-center"><Label data="HeaderTime" /></th>
          <th className="text-start"><Label data="HeaderNOC" /></th>
          <th className="text-start"><Label data="HeaderName" /></th>
          <th className="text-start"><div><Label data="HeaderBib" /></div><div><Label data="HeaderColour" /></div></th>
        </tr>
      </thead>
      <tbody>
        {data?.sort((a, b) => a.startSortOrder - b.startSortOrder)?.map((item, index, self) => {
          const tee = item?.eventUnitEntries?.find(i => i.eue_code === 'START_HOLE')?.eue_value
          const prevTee = index === 0 ? undefined : self[index - 1]?.eventUnitEntries?.find(i => i.eue_code === 'START_HOLE')?.eue_value
          const time = item?.eventUnitEntries?.find(i => i.eue_code === 'START_TIME')?.eue_value
          const prevTime = index === 0 ? undefined : self[index - 1]?.eventUnitEntries?.find(i => i.eue_code === 'START_TIME')?.eue_value
          const bibcolour = item?.eventUnitEntries?.find(i => i.eue_code === 'BIB_COLOUR')?.eue_value

          return (
            <tr key={item?.participant?.code}>
              <td className="text-center">{tee === prevTee ? '' : tee}</td>
              <td className="text-center">{time === prevTime ? '' : time}</td>
              <td className="text-start"><Noc {...item?.participant?.organisation} /></td>
              <td className="text-start"><Competitor hidePicture={true} hideNoc={true} {...item?.participant} /></td>
              <td className="text-start"><SportCode discipline={mirs_discipline} entity='@Colour' code={bibcolour} /></td>
            </tr>
          )
        }
        )
        }
      </tbody>
    </Table>
  )
}



const GlfTeetimes = ({ cumulativeData, unitsData }) => {
  const { mirs_rsc } = useUrlFriendlyToParameters()
  let _phase = getPhaseRSC(mirs_rsc);
  let _currentUnit = getCurrentRound(cumulativeData?.cumulativeResults?.progress?.lastUnit, _phase)
  return (
    <div className="tee-times-main">
      <Accordion defaultActiveKey={_currentUnit}>
        {unitsData?.filter(result => result?.data?.results !== undefined)?.map(result => {
          return (
            <Accordion.Item id={`mirs-accordion-item-${result?.data?.config?.unit}`} key={result?.data?.config?.unit} eventKey={result?.data?.config?.unit}>
              <Accordion.Header>
                <div className="d-flex justify-content-between">
                  <div>{result?.data?.results?.eventUnit?.description}</div>
                </div>
              </Accordion.Header>
              <Accordion.Body >
                <TeeTimesTable data={result?.data?.results?.items} />
              </Accordion.Body>
            </Accordion.Item>
          )
        })
        }
      </Accordion>
    </div>
  );
};

export default GlfTeetimes;
